import groq from 'groq';

export const personQuery = groq`
  name,
  email,
  phone,
  jobtitle,
  "image": image.asset->
`;
